import Vue from 'vue';
import global from '@/plugin/global';
import pluginJK from '@/plugin/jk';
import pluginFilter from '@/filter';

export default ({ app, store }) => {
  Vue.use(global);
  pluginJK({ app });
  pluginFilter({ app, store });
};
